import React, { useState, useEffect } from 'react';
import { Row, Col, Spinner, Modal } from 'react-bootstrap';
import request from '../../../../request';
import Notify from '../../../compartidos/Notify';
import '../Turnero.css';

// Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIdCard, faUserShield, faTags, faSave, faCheck, faUserPlus, faEdit, faTrash, faDesktop } from '@fortawesome/free-solid-svg-icons';

/**
 * UserABM - CRUD for Turnero Staff Users
 */
const UserABM = ({ ipserv, hideHeader = false, branch_id }) => {
    const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState([]);
    const [types, setTypes] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [boxes, setBoxes] = useState([]);
    const [formData, setFormData] = useState({
        UsrNombre: '',
        UsrApellido: '',
        UsrDni: '',
        UsrPassword: '',
        UsrRef1: '',
        UsrRef2: '',
        UsrRef3: '',
        TipoAsociado: [],
        BoxAsociado: []
    });
    const [subStatus, setSubStatus] = useState(null);

    const loadData = () => {
        if (!branch_id) return;
        setLoading(true);
        // Load Users for the specific branch
        request.Get(ipserv + 'getTurneroUsers', { sucursalId: branch_id }, r => {
            if (r.success) setUsers(r.data || []);
        });
        // Load Types for the specific branch
        request.Get(ipserv + 'getTurneroTipos', { sucursalId: branch_id }, r => {
            if (r.success) setTypes(r.rows || []);
        });
        // Load Boxes for the specific branch
        request.Get(ipserv + 'getTurneroBoxes', { sucursalId: branch_id }, r => {
            if (r.success) setBoxes(r.data || []);
            setLoading(false);
        });
    };

    const loadSubscription = () => {
        request.Get(ipserv + 'turnero/subscription-status', {}, r => {
            if (r.success) setSubStatus(r);
        });
    };

    useEffect(() => {
        loadData();
        loadSubscription();
    }, [branch_id]);

    const handleOpenModal = (item = null) => {
        setCurrentItem(item);
        setFormData(item ? {
            ...item,
            UsrPassword: '', // Don't show password in edit
            // Convert comma string to array for the form state
            TipoAsociado: item.TipoAsociado ? String(item.TipoAsociado).split(',') : [],
            BoxAsociado: item.BoxAsociado ? String(item.BoxAsociado).split(',') : []
        } : {
            UsrNombre: '',
            UsrApellido: '',
            UsrDni: '',
            UsrPassword: '',
            UsrRef1: '',
            UsrRef2: '',
            UsrRef3: '',
            TipoAsociado: [],
            BoxAsociado: []
        });
        setShowModal(true);
    };

    const handleSave = (e) => {
        e.preventDefault();
        setLoading(true);
        request.Post(ipserv + 'saveTurneroUser', {
            ...formData,
            TipoAsociado: formData.TipoAsociado.join(','), // Convert back to string for backend
            BoxAsociado: formData.BoxAsociado.join(','),   // Convert back to string for backend
            UsrId: currentItem?.UsrId,
            SucursalId: branch_id
        }, r => {
            if (r.success) {
                Notify({ type: 'success', text: 'Usuario guardado correctamente' });
                setShowModal(false);
                loadData();
            } else {
                Notify({ type: 'fail', text: r.message || 'Error al guardar usuario' });
            }
            setLoading(false);
        });
    };

    return (
        <div className="animate-in">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <h2 style={{ fontWeight: 800, marginBottom: '0.25rem' }}>Personal de Turnero</h2>
                    <p className="text-muted small">Gestiona el equipo de trabajo y sus permisos de atención.</p>
                </div>
                <button
                    className={`auth-btn-primary ${(!subStatus || subStatus.isExpired || users.length >= subStatus.plan.MaxStaff) ? 'opacity-50' : ''}`}
                    style={{ width: 'auto', padding: '0.75rem 1.5rem' }}
                    onClick={() => {
                        if (subStatus?.isExpired) {
                            Notify({ type: 'info', text: 'Tu plan ha vencido. Pásate a modo suscripción para seguir creando.' });
                        } else if (subStatus && users.length >= subStatus.plan.MaxStaff) {
                            Notify({ type: 'info', text: `Límite de staff alcanzado (${subStatus.plan.MaxStaff}) para tu plan ${subStatus.plan.PlanNombre}.` });
                        } else {
                            handleOpenModal();
                        }
                    }}
                >
                    <FontAwesomeIcon icon={faUserPlus} /> Nuevo Usuario
                </button>
            </div>


            <div className="turnero-card p-0 overflow-hidden">
                <table className="table table-dark table-hover m-0">
                    <thead className="bg-glass">
                        <tr>
                            <th className="border-0 p-3">DNI</th>
                            <th className="border-0 p-3">Nombre Completo</th>
                            <th className="border-0 p-3">Tipo Turno</th>
                            <th className="border-0 p-3">Referencias</th>
                            <th className="border-0 p-3">Sucursal</th>
                            <th className="border-0 p-3 text-center">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading && users.length === 0 ? (
                            <tr>
                                <td colSpan="5" className="text-center p-5">
                                    <Spinner animation="border" variant="primary" />
                                </td>
                            </tr>
                        ) : users.length === 0 ? (
                            <tr>
                                <td colSpan="5" className="text-center p-5 text-muted">No hay personal cargado</td>
                            </tr>
                        ) : (
                            users.map(u => (
                                <tr key={u.UsrId} className="animate-in">
                                    <td className="p-3 font-weight-bold">{u.UsrDni}</td>
                                    <td className="p-3">{u.UsrApellido}, {u.UsrNombre}</td>
                                    <td className="p-3">
                                        <div className="d-flex flex-wrap" style={{ gap: '4px' }}>
                                            {u.TipoAsociado ? String(u.TipoAsociado).split(',').map(tid => {
                                                const type = types.find(t => String(t.TipoId) === String(tid));
                                                return type ? (
                                                    <span key={tid} className="turnero-badge bg-info text-white" style={{ fontSize: '0.7rem' }}>
                                                        {type.TipoNombre}
                                                    </span>
                                                ) : null;
                                            }) : <span className="text-muted small">Sin asignar</span>}
                                        </div>
                                    </td>
                                    <td className="p-3 small text-muted">
                                        {u.UsrRef1 && <div>Ref1: {u.UsrRef1}</div>}
                                        {u.UsrRef2 && <div>Ref2: {u.UsrRef2}</div>}
                                    </td>
                                    <td className="p-3 text-muted">{u.SucursalNombre}</td>
                                    <td className="p-3 text-center">
                                        <button className="btn btn-sm btn-outline-info mr-2" onClick={() => handleOpenModal(u)}>
                                            <FontAwesomeIcon icon={faEdit} />
                                        </button>
                                        <button className="btn btn-sm btn-outline-danger">
                                            <FontAwesomeIcon icon={faTrash} />
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg" contentClassName="turnero-card border-0">

                <form onSubmit={handleSave}>
                    <Modal.Body className="text-white px-4">
                        {/* Section: Identification */}
                        <div className="form-header-section">
                            <FontAwesomeIcon icon={faIdCard} className="mr-2" /> Datos de Identificación
                        </div>
                        <Row>
                            <Col md={6} className="mb-3">
                                <label className="small text-muted mb-1">Nombre</label>
                                <input
                                    type="text"
                                    className="turnero-input"
                                    placeholder="Ej: JUAN"
                                    value={formData.UsrNombre}
                                    onChange={e => setFormData({ ...formData, UsrNombre: e.target.value.toUpperCase() })}
                                    required
                                />
                            </Col>
                            <Col md={6} className="mb-3">
                                <label className="small text-muted mb-1">Apellido</label>
                                <input
                                    type="text"
                                    className="turnero-input"
                                    placeholder="Ej: PEREZ"
                                    value={formData.UsrApellido}
                                    onChange={e => setFormData({ ...formData, UsrApellido: e.target.value.toUpperCase() })}
                                    required
                                />
                            </Col>
                            <Col md={12} className="mb-3">
                                <label className="small text-muted mb-1">DNI (Documento Nacional de Identidad)</label>
                                <input
                                    type="text"
                                    className="turnero-input"
                                    placeholder="Número de documento"
                                    value={formData.UsrDni}
                                    onChange={e => setFormData({ ...formData, UsrDni: e.target.value })}
                                    required
                                />
                            </Col>
                        </Row>

                        <div className="turnero-separator"></div>

                        {/* Section: Account & Role */}
                        <div className="form-header-section">
                            <FontAwesomeIcon icon={faUserShield} className="mr-2" /> Seguridad y Acceso
                        </div>
                        <Row>
                            <Col md={6} className="mb-3">
                                <label className="small text-muted mb-1">
                                    {currentItem ? 'Cambiar Contraseña (Opcional)' : 'Contraseña de Acceso'}
                                </label>
                                <input
                                    type="password"
                                    className="turnero-input"
                                    placeholder={currentItem ? "Dejar vacío para mantener" : "Mínimo 6 caracteres"}
                                    value={formData.UsrPassword}
                                    onChange={e => setFormData({ ...formData, UsrPassword: e.target.value })}
                                    required={!currentItem}
                                />
                            </Col>
                            <Col md={6} className="mb-3">
                                <label className="small text-muted mb-1">Sectores Asignados (Múltiple)</label>
                                <div className="turnero-input p-3" style={{ height: 'auto', maxHeight: '180px', overflowY: 'auto' }}>
                                    {types.length === 0 ? (
                                        <div className="text-muted small">No hay sectores configurados</div>
                                    ) : (
                                        types.map(t => (
                                            <div key={t.TipoId} className="custom-control custom-checkbox mb-2">
                                                <input
                                                    type="checkbox"
                                                    className="custom-control-input"
                                                    id={`type-${t.TipoId}`}
                                                    checked={formData.TipoAsociado.includes(String(t.TipoId))}
                                                    onChange={e => {
                                                        const id = String(t.TipoId);
                                                        const current = [...formData.TipoAsociado];
                                                        if (e.target.checked) {
                                                            if (!current.includes(id)) current.push(id);
                                                        } else {
                                                            const idx = current.indexOf(id);
                                                            if (idx > -1) current.splice(idx, 1);
                                                        }
                                                        setFormData({ ...formData, TipoAsociado: current });
                                                    }}
                                                />
                                                <label className="custom-control-label text-white ml-2 clickable" htmlFor={`type-${t.TipoId}`}>
                                                    {t.TipoNombre}
                                                </label>
                                            </div>
                                        ))
                                    )}
                                </div>
                            </Col>

                            <Col md={12} className="mt-3">
                                <label className="small text-muted mb-1">Boxes / Puestos Asignados (Múltiple)</label>
                                <div className="turnero-input p-3" style={{ height: 'auto', maxHeight: '180px', overflowY: 'auto' }}>
                                    {boxes.length === 0 ? (
                                        <div className="text-muted small">No hay boxes configurados para esta sucursal</div>
                                    ) : (
                                        <div className="d-flex flex-wrap" style={{ gap: '1rem' }}>
                                            {boxes.map(b => (
                                                <div key={b.BoxId} className="custom-control custom-checkbox">
                                                    <input
                                                        type="checkbox"
                                                        className="custom-control-input"
                                                        id={`box-${b.BoxId}`}
                                                        checked={formData.BoxAsociado.includes(String(b.BoxId))}
                                                        onChange={e => {
                                                            const id = String(b.BoxId);
                                                            const current = [...formData.BoxAsociado];
                                                            if (e.target.checked) {
                                                                if (!current.includes(id)) current.push(id);
                                                            } else {
                                                                const idx = current.indexOf(id);
                                                                if (idx > -1) current.splice(idx, 1);
                                                            }
                                                            setFormData({ ...formData, BoxAsociado: current });
                                                        }}
                                                    />
                                                    <label className="custom-control-label text-white ml-2 clickable" htmlFor={`box-${b.BoxId}`}>
                                                        <FontAwesomeIcon icon={faDesktop} className="mr-1 opacity-50 small" />
                                                        {b.BoxNombre}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </Col>
                        </Row>

                        <div className="turnero-separator"></div>

                        {/* Section: Additional References */}
                        <div className="form-header-section">
                            <FontAwesomeIcon icon={faTags} className="mr-2" /> Referencias del Sistema
                        </div>
                        <Row>
                            <Col md={4} className="mb-3">
                                <label className="small text-muted mb-1">Ref 1 (Legajo / ID)</label>
                                <input
                                    type="text"
                                    className="turnero-input"
                                    placeholder="ID Interno"
                                    value={formData.UsrRef1}
                                    onChange={e => setFormData({ ...formData, UsrRef1: e.target.value })}
                                />
                            </Col>
                            <Col md={4} className="mb-3">
                                <label className="small text-muted mb-1">Ref 2 (Nro. Cajero)</label>
                                <input
                                    type="text"
                                    className="turnero-input"
                                    placeholder="Caja Asignada"
                                    value={formData.UsrRef2}
                                    onChange={e => setFormData({ ...formData, UsrRef2: e.target.value })}
                                />
                            </Col>
                            <Col md={4} className="mb-3">
                                <label className="small text-muted mb-1">Ref 3 (Otro)</label>
                                <input
                                    type="text"
                                    className="turnero-input"
                                    placeholder="Referencia libre"
                                    value={formData.UsrRef3}
                                    onChange={e => setFormData({ ...formData, UsrRef3: e.target.value })}
                                />
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer className="border-0 px-4 pb-4">
                        <button type="button" className="btn btn-link text-muted" onClick={() => setShowModal(false)}>
                            Cancelar
                        </button>
                        <button type="submit" className="turnero-btn turnero-btn-primary px-5" disabled={loading}>
                            {loading ? <Spinner size="sm" animation="border" /> : (
                                <><FontAwesomeIcon icon={currentItem ? faSave : faCheck} className="mr-2" /> {currentItem ? 'Actualizar' : 'Crear Usuario'}</>
                            )}
                        </button>
                    </Modal.Footer>
                </form>
            </Modal>
        </div>
    );
};

export default UserABM;
